import {
  Box,
  FormControl,
  FormLabel,
  Skeleton,
  TextField,
} from '@mui/material';
import { PageLayout } from '../../../shared/layouts';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ConfirmNavigationHook } from '@gvdasa/components-confirm';
import { C4ModelEquipesService } from '../../../shared/services/api/c4-model/EquipesService';
import { ApiException } from '../../../shared/services/api/ApiException';
import { confirm, feedback } from '../../../shared/services';
import { FerramentasDeDetalhe, Section } from '../../../shared/components';
import { schemaBuilder } from '../../../shared/services/form-validation/Yup';
import { useFormik } from 'formik';

export const DetalheEquipes: React.FC = () => {
  const { id = 'nova' } = useParams<'id'>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [saveAndNew, setSaveAndNew] = useState(false);
  const gvConfirmation = new ConfirmNavigationHook({});
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      nome: '',
    },
    validationSchema: schemaBuilder.object().shape({
      nome: schemaBuilder.string().required().min(3),
    }),
    onSubmit: async (values: { nome: string }) => {
      setIsLoading(true);
      setSaveAndNew(false);
      feedback('Salvando...', 'loading');

      if (id === 'nova') {
        C4ModelEquipesService.createEquipe(values)
          .then(result => {
            feedback('Equipe criada com sucesso', 'success');
            if (saveAndNew) {
              formik.resetForm();
              navigate('/c4-equipes/detalhe/nova');
            } else {
              navigate('/c4-equipes');
            }
          })
          .catch(error => {
            if (error instanceof ApiException) {
              feedback(error.message, 'error');
            }
          });
      }
      else {
        C4ModelEquipesService.updateEquipeById(id, values)
          .then(result => {
            feedback('Equipe atualizada com sucesso', 'success');
            if (saveAndNew) {
              formik.resetForm();
              navigate('/c4-equipes/detalhe/nova');
            } else {
              navigate('/c4-equipes');
            }
          })
          .catch(error => {
            if (error instanceof ApiException) {
              feedback(error.message, 'error');
            }
          });

      }

      setIsLoading(false);
    },
  });

  useEffect(() => {
    if (id === 'nova') {
      setIsLoading(false);
    } else {
      C4ModelEquipesService.getEquipesById(id).then((data) => {
        setIsLoading(false);
        if (data instanceof ApiException) {
          feedback(data.message, 'error');
        } else {
          formik.setValues({ nome: data.nome });
        }
      });
    }
  }, [id]);

  useEffect(() => {
    gvConfirmation.componentDidMount();

    return () => {
      gvConfirmation.componentWillUnmount();
    };
  }, []);

  const handleNovo = () => {
    formik.resetForm();
    navigate('/c4-equipes/detalhe/nova');
  };

  const handleSaveAndNew = () => {
    setSaveAndNew(true);
    formik.submitForm();
  };

  const handleSubmit = useCallback(() => {
    formik.submitForm();
  }, [formik]);

  const handleDelete = useCallback(() => {
    const handleConfirmDelete = () => {
      feedback('Excluindo...!', 'loading');
      C4ModelEquipesService.deleteEquipeById(id)
        .then((result) => {
          feedback(`${formik.values.nome} Excluído com sucesso!`, 'success');
          navigate('/c4-equipes');
        })
        .catch((error) => {
          if (error instanceof ApiException) {
            feedback(error.message, 'error');
          }
        });
    };
    confirm(
      `Tem certeza que deseja excluir ${formik.values.nome}?`,
      'delete',
      handleConfirmDelete
    );
  }, [navigate, id, formik.values.nome]);

  return (
    <PageLayout
      title={id === 'nova' ? 'Nova equipe' : formik.values.nome}
      tools={
        <FerramentasDeDetalhe
          mostrarBotaoDeSalvar
          // desabilitarBotaoApagar={permitirExcluirTermoPadrao}
          // desabilitarBotaoDeSalvar={permitirEditarTermoPadrao}
          mostrarBotaoDeVoltar
          mostrarBotaoDeSalvarENovo={id == 'nova'}
          isBotaoDeNovoLoading={isLoading}
          isBotaoDeApagarLoading={isLoading}
          isBotaoDeSalvarLoading={isLoading}
          isBotaoDeSalvarENovoLoading={isLoading}
          mostrarBotaoDeNovo={id !== 'nova'}
          mostrarBotaoDeApagar={id !== 'nova'}
          mostrarDivider
          aoClicarEmApagar={handleDelete}
          aoClicarEmVoltar={() => {
            navigate('/c4-equipes');
          }}
          aoClicarEmSalvar={formik.submitForm}
          aoClicarEmSalvarENovo={handleSaveAndNew}
          aoClicarEmNovo={handleNovo}
        />
      }
    >
      <Box>
        <Section title="Equipes" margin>
          <Box>
            {!isLoading && (
              <FormControl fullWidth>
                <FormLabel required>Nome</FormLabel>
                <TextField
                  sx={{ maxWidth: '345px' }}
                  variant="outlined"
                  name="nome"
                  value={formik.values.nome}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.nome && Boolean(formik.errors.nome)}
                  helperText={formik.touched.nome && formik.errors.nome}
                />
              </FormControl>
            )}
            {isLoading && (
              <Skeleton
                variant="rectangular"
                animation="pulse"
                height={50}
                width="345px"
              />
            )}
          </Box>
        </Section>
      </Box>
    </PageLayout>
  );
};
